<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol md="6">
        <CHeaderBrand to="/">
          <img src="../assets/logo.png">
        </CHeaderBrand>
        <div class="w-100">
        <div class="clearfix text-center">
          <h1 class="display-3 mr-4">404</h1>
          <h4 class="pt-3">Oops! You're lost.</h4>
          <p class="text-muted">The page you are looking for was not found.</p>
          <a href="/">Go to homepage</a>
        </div>
      </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: 'Page404'
}
</script>
